module.exports = __webpack_public_path__ + "img/bonus3.775b2393.png";